import { render } from "./SpinnerContainer.vue?vue&type=template&id=6c57fba4&scoped=true&ts=true"
import script from "./SpinnerContainer.vue?vue&type=script&lang=ts"
export * from "./SpinnerContainer.vue?vue&type=script&lang=ts"

import "./SpinnerContainer.vue?vue&type=style&index=0&id=6c57fba4&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c57fba4"]])

export default __exports__